import { render, staticRenderFns } from "./HomeEn.vue?vue&type=template&id=3920aeb8&scoped=true&"
import script from "./HomeEn.vue?vue&type=script&lang=js&"
export * from "./HomeEn.vue?vue&type=script&lang=js&"
import style0 from "./HomeEn.vue?vue&type=style&index=0&id=3920aeb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920aeb8",
  null
  
)

export default component.exports